import { render, staticRenderFns } from "./pcp-classical-evaluation.vue?vue&type=template&id=64e83c00"
import script from "./pcp-classical-evaluation.vue?vue&type=script&lang=js"
export * from "./pcp-classical-evaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports